import { useEffect, useState } from "react";
import UserAPI from "../apis/UserAPI";

const useAttempt = (lessonId, userId = undefined) => {
  const [attempt, setAttempt] = useState(undefined);

  useEffect(() => {
    if (!lessonId) return;

    setAttempt(undefined);
    const unsubscribe = UserAPI.subscribeToAttemptDetails(
      lessonId,
      (key, value) => setAttempt((state) => ({ ...state, [key]: value })),
      (key) => setAttempt((state) => ({ ...state, [key]: undefined })),
      userId
    );
    return () => unsubscribe();
  }, [lessonId, userId]);

  return attempt;
};

export { useAttempt };
